import {Tooltip} from "@mui/material";

export function AutoTooltipInfo(props: React.PropsWithChildren<{
    value: any;
}>) {
    if(!props.value) {
        return <>{props.children}</>
    }

    return <Tooltip title={props.value}>{props.children as any}</Tooltip>
}